// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WifiSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.11 25.991a1.5 1.5 0 1 1-2.22 2.018l-6.418-7.059a7.006 7.006 0 0 0-6.588.887 1.5 1.5 0 0 1-1.768-2.424 9.919 9.919 0 0 1 5.24-1.89l-2.417-2.66a13.022 13.022 0 0 0-5.008 2.443 1.5 1.5 0 0 1-1.862-2.351 16.057 16.057 0 0 1 4.632-2.554l-2.164-2.375a18.892 18.892 0 0 0-4.585 2.785A1.502 1.502 0 0 1 2.05 10.49 21.938 21.938 0 0 1 6.424 7.69L4.89 6.01A1.5 1.5 0 1 1 7.11 3.99l20 22ZM16 23.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8.069-6.194a1.5 1.5 0 0 0 1.862-2.351 15.91 15.91 0 0 0-4.681-2.574 1.5 1.5 0 0 0-.984 2.834 12.951 12.951 0 0 1 3.803 2.091Zm5.882-6.817a22.041 22.041 0 0 0-15.434-4.94 1.503 1.503 0 0 0 .2 3 19.03 19.03 0 0 1 13.331 4.265 1.5 1.5 0 0 0 1.903-2.319v-.006Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
